<template>
  <b-modal
    :id="id"
    :title="trans('choose_a_gift_card')"
    :ok-title="trans('choose')"
    :ok-disabled="!gift_card"
    :cancel-title="trans('cancel')"
    size="lg"
    @shown="onShown"
    @hidden="onHidden"
    @ok="onChoose"
  >
    <b-row class="mb-3">
      <b-col>
        <search-form
          v-model="search"
          :name-placeholder="`${trans('gift_card')} / ${trans('client')}`"
          @input="onSearch"
          :disabled="busy"
        ></search-form>
      </b-col>
    </b-row>
    <b-overlay :show="busy">
      <b-table
        ref="table"
        id="gift_cards"
        class="bg-white table-row-click"
        small
        hover
        responsive
        show-empty
        :per-page="perPage"
        :current-page="currentPage"
        :fields="fields"
        :items="provider"
        :tbody-tr-class="rowClass"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @row-clicked="onRowClick"
      >
        <template v-slot:empty>
          <h4 v-if="busy" align="center">
            <i class="fa fa-circle-notch fa-spin"></i>
            {{ trans('loading') }}
          </h4>
          <p v-if="!busy" align="center">{{ trans('none') }}</p>
        </template>
        <template v-slot:cell(name)="data">
          {{ data.value }}
          <b-badge v-if="data.item.deleted_at" variant="danger">
            {{ trans('archived') }}
          </b-badge>
          <small class="d-block text-muted">{{ data.item.no_display }}</small>
        </template>
        <template #cell(recipient)="data">
          <address v-if="data.value">
            {{ data.value.name }}
            <small class="d-block">{{ data.value.email }}</small>
            <small v-if="data.value.mobile" class="d-block">{{ data.value.mobile }}</small>
          </address>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
        aria-controls="gift_cards"
        align="center"
        :disabled="busy"
      ></b-pagination>
    </b-overlay>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import SearchForm from './../../../common/components/SearchRecipientsForm'

  export default {
    props: {
      id: {
        type: String,
        default: 'admin-choose-gift-card-modal',
      },
      organization: Object,
      email: String,
      notEmpty: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      SearchForm,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        gift_card: null,
        search: {
          name: null,
          email: this.email || null,
          mobile: null,
        },
        items: null,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        sortBy: null,
        sortDesc: false,
      }
    },
    computed: {
      fields() {
        return [
          {key: 'name', label: trans('gift_card'), sortable: true},
          {key: 'recipient', label: trans('client'), sortable: true},
          {
            key: 'balance',
            label: trans('balance'),
            formatter(value, key, item) {
              return numeral(parseFloat(value)).format('0.00')
            },
            sortable: true,
          },
        ]
      },
    },
    methods: {
      onShown() {
        this.search = {
          name: null,
          email: this.email || null,
          mobile: null,
        }
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.gift_card = null
      },
      onChoose() {
        this.$emit('chosen', this.gift_card)
      },
      rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.selected) return 'table-primary'
      },
      onRowClick(gift_card) {
        if (this.gift_card && this.gift_card.id != gift_card.id) this.gift_card.selected = false
        this.gift_card = gift_card
        this.gift_card.selected = true
      },
      onSearch() {
        this.currentPage = 1
        this.onRefresh()
      },
      onRefresh() {
        this.$refs.table.refresh()
      },
      buildItems(gift_cards) {
        return _.reduce(gift_cards || [], (gift_cards, gift_card) => {
          gift_card.selected = false
          gift_cards.push(gift_card)
          return gift_cards
        }, [])
      },
      provider() {
        this.busy = true
        this.error = null
        let query = `?&page=${this.currentPage}&per_page=${this.perPage}`
        if (this.search.name) query += `&name=${encodeURIComponent(this.search.name)}`
        if (this.search.mobile) query += `&mobile=${encodeURIComponent(this.search.mobile)}`
        if (this.search.email) query += `&email=${encodeURIComponent(this.search.email)}`
        if (this.notEmpty) query += `&not_empty=true`
        if (this.sortBy) {
          query += `&order=${this.sortBy}`
          query += `&dir=${this.sortDesc ? 'desc' : 'asc'}`
        }
        let url = `/organization/${this.organization.id}/gift_card/list${query}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.currentPage = response.data.current_page
          this.perPage = response.data.per_page
          this.totalRows = response.data.total
          this.items = this.buildItems(response.data.data)
          return this.items
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.items = []
          return this.items
        })
      },
    },
    mounted() {
      window.adminChooseGiftCardModal = this
    },
  }
</script>